import { Avatar, Box, Grid } from "@mui/material";
import { AppImageDimension } from "app/appImages";
import { MprcContainer } from "components";
import { EnrollStatus, TrainingAssessmentItemDto } from "generated/CoreApi_v1";
import { LmsTrainingDefaultThumbnailUrl } from "views/lms/components/LmsTypeImage";
import { TrainingInteractions } from "views/lms/student/EnrollmentView/Shared/TrainingInteractions";
import { useEnrollmentViewContext } from "../../..";
import { EnrollmentStatus } from "../../../Shared/EnrollmentStatus";
import { TrainingDueDate } from "../../../Shared/TrainingDueDate";
import { ActionButtonAssessment } from "./TrainingAssessmentActions";
import { TrainingAssessmentDataBox } from "./TrainingAssessmentDataBox";

interface IProps {
    assessment: TrainingAssessmentItemDto;
}

/////////////////////////////////////////////////////////////////////////////////////

export const TrainingAssessmentHeaderContent = (props: IProps) => {

    const { assessment } = props;
    const { enrollment, onReload } = useEnrollmentViewContext();

    return (
        <Grid container direction="column" spacing={1} mt={1}>
            <Grid>
                <Box
                    display="grid"
                    gridTemplateColumns="min-content auto"
                    columnGap={2}
                    rowGap={1}
                >
                    <Box>
                        <Avatar
                            variant="rounded"
                            sx={{ ...AppImageDimension.ThumbnailLg }}
                            src={LmsTrainingDefaultThumbnailUrl(enrollment.trainingContentType, enrollment.trainingThumbnailUrl)}
                        />
                    </Box>
                    <Box>
                        {
                            (enrollment?.status == EnrollStatus.Approved || enrollment.status == EnrollStatus.Reproved)
                                ?
                                <MprcContainer>
                                    <EnrollmentStatus variant="block" data={enrollment!} />
                                </MprcContainer>
                                :
                                !(assessment.scorePending && (assessment.maxTries == 0 || assessment.remaingTries == 0)) &&
                                <MprcContainer>
                                    <TrainingDueDate enrollment={enrollment} />
                                </MprcContainer>
                        }
                        <TrainingAssessmentDataBox
                            assessment={assessment}
                            enrollmentId={enrollment.enrollmentId}
                            componentId={enrollment.course!.components[0].componentId}
                            previewMode={enrollment.isPreview}
                            header
                            onReload={onReload}
                        />
                    </Box>
                    <Box>
                        <ActionButtonAssessment
                            assessment={assessment}
                            enrollmentId={enrollment.enrollmentId}
                            componentId={enrollment.course!.components[0].componentId}
                            enrollment={enrollment}
                            onRefresh={onReload}
                        />
                    </Box>
                    <Box>
                        <TrainingInteractions enrollment={enrollment} readOnly={enrollment.isPreview} />
                    </Box>
                </Box>
            </Grid>
        </Grid >
    );
};
